import { render, staticRenderFns } from "./AddTagsPopup.vue?vue&type=template&id=19b7d566"
import script from "./AddTagsPopup.vue?vue&type=script&lang=js"
export * from "./AddTagsPopup.vue?vue&type=script&lang=js"
import style0 from "./AddTagsPopup.vue?vue&type=style&index=0&id=19b7d566&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports